import { useCallback } from 'react'
import { createFileRoute, useNavigate, useSearch } from '@tanstack/react-router'

import { SHIPMENT_STAGES } from '#/entities/shipment'
import { ShipmentDetailsPage } from '#/pages/shipment'
import { useShipmentSidebar } from '#/widgets/shipment-sidebar'

export const Route = createFileRoute('/_shell/orders/$orderId/')({
  component: DetailsRoute,
})

function DetailsRoute() {
  const { orderId } = Route.useParams()
  const navigate = useNavigate()
  const listSearch = useSearch({ strict: false })
  const handleClose = useCallback(() => {
    void navigate({ to: '/orders', search: listSearch as never })
  }, [navigate, listSearch])
  const openShipmentSidebar = useShipmentSidebar(SHIPMENT_STAGES.ORDER)
  const handleMinimize = useCallback(async () => {
    await navigate({ to: '/orders', search: listSearch as never })
    openShipmentSidebar(orderId)
  }, [navigate, listSearch, openShipmentSidebar, orderId])
  return (
    <ShipmentDetailsPage
      stage={SHIPMENT_STAGES.ORDER}
      shipmentId={orderId}
      onClose={handleClose}
      onMinimize={() => void handleMinimize()}
    />
  )
}
